import PastIntervalSelector from 'components/elements/PastIntervalSelect';
import { useDashboardStartDate } from 'state/dashboard';

const DateUpdatedOverlayFilter = () => {
  const [startDate, setStartDate] = useDashboardStartDate();

  return (
    <PastIntervalSelector
      placeholder="Date Updated"
      aria-label="Date Updated Filter"
      value={startDate}
      onChange={setStartDate}
    />
  );
};

export default DateUpdatedOverlayFilter;
